/**
 * LWcustom - Modify this array to include any models that have special display names
 */
export const customTitles = [
  {
    original: "profile_node",
    display: "Memorial Profiles",
  },
  {
    original: "content_node",
    display: "Guardians",
  },
  {
    original: "video_node",
    display: "Feature Videos",
  },
];

export interface IDropdownOption {
  label?: string;
  value: string | number;
}

export interface IDropdownMapping {
  model: string;
  field: string;
  options: IDropdownOption[];
}

/**
 * Custom dropdown options. Forms will intercept these models and fields to add dropdown options to them
 */
export const dropdownFields = [
  {
    model: "model_name",
    field: "fieldName or column_name",
    options: [
      { label: "what shows on the dropdown", value: "optionValue" },
      { label: "label", value: "value" },
    ],
  },
  {
    model: "media_item",
    field: "type",
    options: [
      { label: "Image", value: "image" },
      { label: "Video", value: "video" },
    ],
  },
  {
    model: "attract_media_item",
    field: "type",
    options: [
      { label: "Image", value: "image" },
      { label: "Video", value: "video" },
    ],
  },
  {
    model: "users",
    field: "user_role",
    options: [
      { label: "Admin", value: "admin" },
      { label: "User", value: "user" },
    ],
  },
];

interface ICustomField {
  original: string;
  display?: string;
  hint?: string;
  optional?: boolean;
  accept?: string;
  modelSpecific?: ICustomFieldModelSpecific[];
  hide?: boolean;
}

interface ICustomFieldModelSpecific {
  modelName: string;
  display?: string;
  hint?: string;
  accept?: string;
  optional?: boolean;
  hide?: boolean;
}

/**
 * LWcustom - Modify this array to include model fields that have custom display names and hints on their forms
 */
export const customFieldNames: ICustomField[] = [
  {
    original: "template_custom_item",
    display: "Template Custom Item",
    hint: "Hints for fields",
    modelSpecific: [
      {
        modelName: "model_name",
        display: "This model's field will be displayed as this name",
        hint: "This model will get this hint",
      },
    ],
  },
  {
    original: "thumbnail_src",
    display: "Thumbnail",
    hint: "Must be a JPG or PNG file, 800 x 800px @ 72dpi. Filenames must not have spaces or special characters",
    optional: false,
  },
  {
    original: "full_resolution_image",
    optional: false,
  },
  {
    original: "subtitle_file",
    accept: "srt",
    hide: true,
  },
  {
    original: "mfa_enabled",
    display: "Enable MFA",
  },
  {
    original: "name",
    optional: false,
    modelSpecific: [
      {
        modelName: "profile_node",
        hint: "Max 4 words",
      },
    ],
  },
  {
    original: "subheading",
    modelSpecific: [
      {
        modelName: "profile_node",
        display: "Location",
        hint: "Add the profile's suburb and state",
      },
    ],
  },
  {
    original: "description",
    optional: false,
    modelSpecific: [
      {
        modelName: "profile_node",
        hint: "Max 100 words",
      },
    ],
  },
  {
    original: "thumbnail",
    modelSpecific: [
      {
        modelName: "profile_node",
        hint: "Must be a JPG or PNG file, 220 x 220px @ 72dpi. Filenames must not have spaces or special characters",
      },
      {
        modelName: "video_node",
        optional: false,
        hint: "Must be a JPG or PNG file, 400 x 400px @ 72dpi. Filenames must not have spaces or special characters",
      },
      {
        modelName: "content_node",
        hint: "Must be a JPG or PNG file, 310 x 310px @ 72dpi. Filenames must not have spaces or special characters",
      },
    ],
  },
  {
    original: "short_caption",
    hint: "Max 25 words",
  },
  {
    original: "title",
    optional: false,
    modelSpecific: [
      {
        modelName: "video_node",
        hint: "Max 5 words",
      },
      {
        modelName: "content_node",
        display: "Name",
        hint: "Max 4 words",
      },
    ],
  },
  {
    original: "video_file",
    optional: false,
    hint: "Must be an optimised H.264 MP4 file, 3840 x 2160px. Filenames must not have spaces or special characters",
  },
  {
    original: "email",
    optional: false,
  },
  {
    original: "user_role",
    optional: false,
  },
];
